// John Eldhose 20180511
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox, Divider, Grid, IconButton, InputAdornment, Snackbar, TextField, Typography } from '@material-ui/core';
import { Person, Send, VpnKey, Visibility, VisibilityOff } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { login } from '../Api/login';
import { myProducts } from '../Api/myProducts';

class Login extends Component {

  state = {
    username: '',
    password: '',
    showPassword: false,
    clicked: false,
    loginHelper: '',
    usernameError: false,
    passwordError: false,
    loginError: false,
    remember: false
  };
  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.handleClickLogin();
      e.preventDefault();
    }
  }
  handleUserInput (event, lower = false) {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
    const error = event.target.name + 'Error';
    this.setState({ [error]: false });
  }
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  handleMouseDownPassword = event => {
    event.preventDefault();
  };
  loadMaintenance = () => {
    myProducts(1, 0, [{id: 'EXPIRY_DATE', desc: true}])
      .then((prod) => {
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleClickLogin = () => {
    this.setState({ clicked: true });
    login(this.state.username, this.state.password, this.state.remember)
      .then((auth) => {
        if(auth['status'] === 'true') {
          this.loadMaintenance();
          window.location = '/';
        }
        else {
          if(auth['error'] !== '') {
            this.setState({ loginHelper: auth['error'] });
            this.setState({ loginError: true });
          }
          let fld = '';
          if(auth['fields'].length > 0) {
            auth['fields'].map((field) => {
              fld = field + 'Error';
              this.setState({ [fld]: true });
              return false;
            })
          }
          this.setState({ clicked: false })
        }
      })
      .catch((error) => {
        this.setState({ loginHelper: 'Login failed' });
        this.setState({ loginError: true });
        this.setState({ clicked: false });
      })
  }
  clearLoginError = () => {
    this.setState({ loginError: false })
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <font color='#385687'>Carlson Customer Login</font>
        </Typography>
        <Typography variant='title'>
          <font color='black'>
            <FormattedMessage
              id='Log into your Carlson Account'
              defaultMessage='Log into your Carlson Account'
            />
          </font>
        </Typography>
        <p />
        <Typography variant='subheading'>
          <FormattedMessage
            id='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
            defaultMessage='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
          />
        </Typography>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Person className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Username or Email address'
                defaultMessage='Username or Email address'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='username'
                    value={this.state.username}
                    error={this.state.usernameError}
                    helperText={this.state.usernameHelper}
                    onKeyPress={(event) => this.handleEnter(event)}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <VpnKey className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage id='Password' defaultMessage='Password'>
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    type={this.state.showPassword ? 'text' : 'password'}
                    label={msg}
                    name='password'
                    error={this.state.passwordError}
                    helperText={this.state.passwordHelper}
                    onKeyPress={(event) => this.handleEnter(event)}
                    onChange={(event) => this.handleUserInput(event)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <div style={{ textAlign: 'left' }}>
          <Typography variant='subheading'>
            <Checkbox
              checked={this.state.remember}
              onChange={ (event) => {
                this.setState({ remember: event.target.checked });
              } }
              value="checkedB"
              color="primary"
            />
            <FormattedMessage
              id='Remember me'
              defaultMessage='Remember me'
            />
          </Typography>
        </div>
        <Button
          variant='raised'
          color='primary'
          fullWidth
          onClick={this.handleClickLogin}
          disabled={this.state.clicked}
        >
          <FormattedMessage
            id='Login'
            defaultMessage='Login'
          /> &nbsp;
          <Send />
        </Button>
        <p />
        <Divider />
        <p />
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={4}>
            <Button component={Link} to='/signup' fullWidth variant='raised' color='primary'>
              <FormattedMessage
                id='Sign Up'
                defaultMessage='Sign Up'
              />
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Button component={Link} to='/resendverify' fullWidth variant='raised'>
              <FormattedMessage
                id='Resend verification email'
                defaultMessage='Resend verification email'
              />
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Button component={Link} to='/recover' fullWidth variant='raised' color='primary'>
              <FormattedMessage
                id='Forgot Password'
                defaultMessage='Forgot Password'
              />
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.loginError}
          onClose={this.clearLoginError}
          message={
            <span style={{ color: 'red' }}>
              {this.state.loginHelper}
            </span>
          }
        />
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js